<template>
    <div class="mb-5 relative">
        <div class="mb-2 text-14">
            {{ title }}
        </div>
        <div class="main-body flex flex-col min-w-0">
            <template v-if="imgPreview == null">
                <div class="rounded-10 bg-a-orange-fe5000 bg-opacity-15 p-4 h-full w-full flex flex-col gap-2.5 items-center justify-center"
                    @click="clickChooseFile">
                    <div class="rounded-full bg-white">
                        <img src="@/assets/icon/ic-camera.svg" alt="camera" />
                    </div>
                    <div class="text-14">
                        Upload ภาพถ่าย
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="rounded-10 flex flex-col min-w-0 h-full w-full overflow-hidden bg-a-gray-a8a8a8 relative">
                    <!-- <img :src="imgPreview" alt="preview" class="object-contain h-full w-full" /> -->
                    <div class="object-contain h-full w-full imgPreview" :style="{'background-image': 'url('+imgPreview+')'}"></div>

                    <button type="button"
                        class="rounded-full bg-white h-7 px-2 absolute top-2.5 right-2.5 text-12 text-a-orange-fe5000"
                        @click="clickChooseFile()">
                        <div class="flex items-center gap-2.5">
                            <img class="h-7 w-7" src="@/assets/icon/ic-camera.svg" alt="camera" />
                            <div>
                                แก้ไขภาพ
                            </div>
                        </div>
                    </button>
                </div>
            </template>
        </div>
        <template v-if="hasError">
            <div class="text-red-500 text-xs font-normal w-full text-right mt-1">
                {{ requireMsg }}
            </div>
        </template>

        <input ref="elInputFile" type="file" class="w-0 h-0 hidden" accept="image/*" @change="onFileChange" />
    </div>
</template>
<script>
import { computed, ref } from 'vue';
import ResizeImage from '@/helper/ResizeImage';

export default {
    props: {
        modelValue: {
            type: [File, Blob]
        },
        title: {
            type: String
        },
        required: {
            type: Boolean
        },
        requireMsg: {
            type: String
        },
        isSubmitted: {
            type: Boolean
        },
        isDisable: {type: Boolean, default: false}
    },
    emits: ["update:modelValue"],
    setup: function (props, ctx) {
        const elInputFile = ref(null)
        const imgPreview = ref()
        const imageHelper = new ResizeImage()

        const inputValue = computed({
            get: function () {
                return props.modelValue
            },
            set: function (file) {
                ctx.emit("update:modelValue", file)
            }
        })

        const hasError = computed(() => {
            if (props.required == true && props.isSubmitted == true && inputValue.value == null) {
                return true
            }
            return false
        })

        /**
         * 
         * @param {File} file 
         */
        const processFile = function (file) {
            // resize and set to inputValue and generate preview
            imageHelper.resize(file, (blob, dataUrl) => {
                inputValue.value = blob
                imgPreview.value = dataUrl
            })
        }

        /**
         * 
         * @param {Event} e
         */
        const onFileChange = function (e) {
            // console.log(e.target.files)
            if (e.target.files.length > 0) {
                processFile(e.target.files[0])
            } else {
                clearFile()
            }
        }

        const clearFile = function () {
            imgPreview.value = null
            inputValue.value = null
            // imgPreview.value = null
            elInputFile.value.value = null
        }

        const clickChooseFile = function () {
            if (this.isDisable) return
            elInputFile.value.click()
        }

        return {
            elInputFile,
            inputValue,
            imgPreview,
            hasError,
            onFileChange,
            clickChooseFile
        }
    }
}
</script>

<style lang="scss" scoped>
.main-body {
    height: 168px;
    max-height: 168px;
}
.imgPreview {
    background-size: cover;
    background-position: center;
}
</style>